export const useOnboardingTrackerEligible = () => {
	return {
		isOnboardingTrackerExperimentEligible: false,
		isTrackerDismissed: true,
		loading: false,
		error: null,
	};
};
